export default __webpack_public_path__ + "static/media/bleedingpuncture4.1aac1f36.png";